// extracted by mini-css-extract-plugin
module.exports = {"password":"PasswordModal_password__3fUXz","confirmText":"PasswordModal_confirmText__1GeYL"};